import { BusinessCategory, LessonLearned, LessonLearnedInstances, OpportunityRegister, Plant, RiskRegister, TemporalProjectPricingBlocks, TemporalProjectPricingPrices, TemporalProjectPricingTemplate, TemporalProjectPricingType } from "../../../table_configuration/Project"
import { PalantirTextField, PalantirDispatchedTextField, makeTextMaskNumber } from "../../../../components/input/Text"
import { PalantirAutocomplete, PalantirBooleanSelector, PalantirDatePicker, PalantirSelector, } from "../../../../components/input/SelectPicker"
import { useChangeLog } from "../../../../hooks/changeLog"
import { useDBViewFormValidation } from "../../../../hooks/databaseViewFormValidation"
import ViewPanel from "../../ViewPanel"
import { generateUUID } from "../../../../utils/databaseAppUtils"
import { useState } from "react"
import { DialogProvider, useDialog } from "../../../../components/dialog/DialogProvider"
import { DialogContentText } from "@mui/material"
import { PalantirBasicCRUDMenu } from "../../../../components/menuv2/Menu"
import { Text, SegmentedControl, Badge, Alert } from "@mantine/core"
import { Counterparty, Employee } from "../../../table_configuration/Entity"
import _ from 'lodash'
import { AddFloaterButtonWithPrompt, DeleteFloaterButtonWithPrompt } from "../../../../components/button/FloaterButtonWithPrompt"
import { ProjectPermittingTracker, ProjectPermit } from "../../../table_configuration/Contract"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons"


const makePermittingContractRecord = (projectId) => {
    const record = ProjectPermit.buildNewRecord()
    record[ProjectPermit.columnSchema.oid] = generateUUID()
    record[ProjectPermit.columnSchema.projectId] = projectId
    return record
}


export default function PermittingPanelProxy(props) {

    const permittingTracker = props.data[ProjectPermittingTracker.buildId()].find(x => x[ProjectPermittingTracker.columnSchema.projectId]===props.selectedPlantId)
    const permittingContracts = props.data[ProjectPermit.buildId()].filter(x => x[ProjectPermit.columnSchema.projectId]===props.selectedPlantId)

    return (
        <DialogProvider>
            <PermittingPanel
                initialPermittingTracker={permittingTracker}
                initialPermittingContracts={permittingContracts}
                {...props}
            />
        </DialogProvider>
    )
}

function PermittingPanel({initialPermittingTracker, initialPermittingContracts, initialPermittingContractDates, counterparties, ...props}) {

    const [
        trackerRecords, prepareTrackerLog, updateTrackerLog, addToTrackerLog,
        deleteFromTrackerLog, bulkOpOnTrackerLog, mergeAndResetTrackerLog, resetTrackerLog, popFromTrackerLog
    ] = useChangeLog(initialPermittingTracker ? [initialPermittingTracker] : [], ProjectPermittingTracker)
    const [
        contractRecords, prepareContractLog, updateContractLog, addToContractLog,
        deleteFromContractLog, bulkOpOnContractLog, mergeAndResetContractLog, resetContractLog, popFromContractLog
    ] = useChangeLog(initialPermittingContracts, ProjectPermit)
    /*const [
        contractDatesRecords, prepareContractDatesLog, updateContractDatesLog, addToContractDatesLog,
        deleteFromContractDatesLog, bulkOpOnContractDatesLog, mergeAndResetContractDatesLog, resetContractDatesLog, popFromContractDatesLog
    ] = useChangeLog(initialPermittingContractDates, PermittingDatesContract)*/
    
    const [errors, addErrors, removeErrors, setErrors, verifyChangelogSubmission, resetErrors] = useDBViewFormValidation()

    const tracker = trackerRecords[0] || {}
    
    const addNewPermittingContract = () => {
        const record = ProjectPermit.buildNewRecord()
        record[ProjectPermit.columnSchema.oid] = generateUUID()
        record[ProjectPermit.columnSchema.projectId] = props.selectedPlantId
        addToContractLog(record)
    }
    /*const addNewPermittinContractDate = (contractId) => {
        const record = PermittingDatesContract.buildNewRecord()
        record[PermittingDatesContract.columnSchema.oid] = generateUUID()
        record[PermittingDatesContract.columnSchema.contractId] = contractId
        addToContractDatesLog(record)
    }*/

    const updateTracker = (update) => {
        if (_.isEmpty(tracker)) {
            const record = ProjectPermittingTracker.buildNewRecord()
            record[ProjectPermittingTracker.columnSchema.id] = generateUUID()
            record[ProjectPermittingTracker.columnSchema.name] = props.selectedPlant[Plant.columnSchema.plantName]
            record[ProjectPermittingTracker.columnSchema.projectId] = props.selectedPlantId
            Object.assign(record, update)
            addToTrackerLog(record)
        }
        else {
            updateTrackerLog(tracker, update)
        }
    }

    let ctr = 3
    const items = contractRecords.map(contractRecord => {

        const contractItemIdx = ctr
        ctr+=1
        //const contractDateTableIdx = ctr
        //ctr+=1

        const contractId = contractRecord[ProjectPermit.columnSchema.oid]
        //const filteredContractDates = _.sortBy(contractDatesRecords.filter(x => x[PermittingDatesContract.columnSchema.contractId]===contractId), PermittingDatesContract.columnSchema.startDate)

        return (
            <ContractItem
                contractItemRow={contractItemIdx}
                //contractDateTableRow={contractDateTableIdx}
                contract={contractRecord}
                //contractDates={filteredContractDates}
                //counterparties={counterparties}
                //addContractDate={() => addNewPermittinContractDate(contractId)}
                updateContract={(update) => updateContractLog(contractRecord, update)}
                //updateContractDatesLog={updateContractDatesLog}
                deleteContract={() => {
                    deleteFromContractLog(contractRecord)
                    //deleteFromContractDatesLog(filteredContractDates)
                }}
                //deleteContractDate={deleteFromContractDatesLog}
            />
        )
    })

    return (
        <ViewPanel
            services={props.services}
            title="Permitting"
            submitUrl='/api/precious/table/permitting_contract'
            verifySubmit={(payload) => {
                return verifyChangelogSubmission(
                    {
                        changeLog: payload.trackerChangeLog,
                        checks: []
                    }, {
                        changeLog: payload.permitChangeLog,
                        checks: []
                    }
                )
            }}
            onSubmitSuccess={(response, requestPayload) => {
                props.handleUpdate(false)
                resetErrors()
                mergeAndResetContractLog()
                mergeAndResetTrackerLog()
            }}
            onSubmitError={null}
            buildSubmitPayload={() => {
                return {
                    trackerChangeLog: prepareTrackerLog(),
                    permitChangeLog: prepareContractLog(),
                }
            }}
        >
            <div className="form-instance" style={{minWidth: "1500px", paddingLeft: "40px"}}>
                <Text weight={500} style={{}} size="lg">Permitting</Text>
                <div className="flow-horizontal" style={{marginTop: "10px", marginBottom: "10px"}}>
                    <PalantirDatePicker
                        label="Permitting Completed Date"
                        value={tracker[ProjectPermittingTracker.columnSchema.permittingCompletedDate]}
                        onChange={(x) => updateTracker({[ProjectPermittingTracker.columnSchema.permittingCompletedDate]: x})}
                        style={{width: "275px", marginRight: "15px", marginTop: "4px"}}
                    />
                    <PalantirDispatchedTextField
                        label="Notes"
                        value={tracker[ProjectPermittingTracker.columnSchema.notes]===undefined ? null : tracker[ProjectPermittingTracker.columnSchema.notes]}
                        onChange={(x) => updateTracker({[ProjectPermittingTracker.columnSchema.notes]: x})}
                        multiline
                        maxRows={2}
                        fullWidth
                        variant="filled"
                    />
                </div>
                <div style={{display: "grid", gridTemplateColumns: "50px auto 180px 140px 140px 140px auto", gridTemplateRows: "30px 40px auto", columnGap: "20px", rowGap: "10px"}}>
                    <Text weight={500} style={{gridRow: 1, gridColumn: "1 / -1"}} size="lg">Permits</Text>
                    <div style={{gridRow: 2, gridColumn: 1}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>ID</Text></div>
                    <div style={{gridRow: 2, gridColumn: 2}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Name</Text></div>
                    {/*<div style={{gridRow: 2, gridColumn: 3}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Status</Text></div>*/}
                    <div style={{gridRow: 2, gridColumn: 3}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Authorizing Agency</Text></div>
                    <div style={{gridRow: 2, gridColumn: 4}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Approval Date</Text></div>
                    <div style={{gridRow: 2, gridColumn: 5}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Expiration Date</Text></div>
                    <div style={{gridRow: 2, gridColumn: 6}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Document Link</Text></div>
                    <div style={{gridRow: 2, gridColumn: 7}}><Text size="lg" style={{borderBottom: "solid grey 1px"}}>Description</Text></div>
                    {items}
                    <div style={{gridRow: ctr, gridColumn: "1 / -1"}}>
                        <AddFloaterButtonWithPrompt
                            onClick={addNewPermittingContract}
                            labelContent="Add permit"
                        />
                    </div>
                </div>
            </div>
        </ViewPanel>
    )
}

const ContractItem = ({contractItemRow, contractDateTableRow, contract, contractDates, counterparties, updateContract, updateContractDatesLog, addContractDate, deleteContract, deleteContractDate}) => {

    //const [isContractDatesVisible, setIsContractDatesVisible] = useState(false)
    /*const toggleIsContractDatesVisible = () => {
        setIsContractDatesVisible(!isContractDatesVisible)
    }*/

    //const counterpartyId = contract[ProjectPermit.columnSchema.responsibility]
    //const counterparty = counterparties.find(x => x[Counterparty.columnSchema.counterpartyId]===counterpartyId) || {}

    //let contractDateTableCtr = 3
    /*const filteredContractDateComponents = contractDates.map(contractDate => {

        const contractDateIdx = contractDateTableCtr
        contractDateTableCtr+=1

        return (
            <ContractDate
                gridRow={contractDateIdx}
                contractDate={contractDate}
                updateContractDate={(update) => updateContractDatesLog(contractDate, update)}
                deleteContractDate={() => deleteContractDate(contractDate)}
            />
        )
    })*/

    return (
        <>
            <DeleteFloaterButtonWithPrompt
                onClick={deleteContract}
                style={{gridRow: contractItemRow, gridColumn: 1, width: "15px", position: "relative", top: "8px", right: "26px", display: "block"}}
            />
            {/*<div style={{gridRow: contractItemRow, gridColumn: 1, width: "15px", position: "relative", top: "8px", right: "18px"}}>
                <FontAwesomeIcon
                    onClick={toggleIsContractDatesVisible}
                    icon={isContractDatesVisible ? faAngleDown : faAngleRight}
                    style={{}}
                />
            </div>*/}
            <PalantirTextField
                value={contract[ProjectPermit.columnSchema.oid]}
                disabled
                style={{gridRow: contractItemRow, gridColumn: 1}}
            />
            <PalantirTextField
                value={contract[ProjectPermit.columnSchema.permitName]}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.permitName]: x})}
                style={{gridRow: contractItemRow, gridColumn: 2}}
            />
            {/*<PalantirSelector
                value={contract[ProjectPermit.columnSchema.status]}
                items={ProjectPermit.options.status}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.status]: x})}
                style={{gridRow: contractItemRow, gridColumn: 3, minWidth: "0px"}}
            />*/}
            <PalantirDispatchedTextField
                value={contract[ProjectPermit.columnSchema.authorizingAgency]}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.authorizingAgency]: x})}
                style={{gridRow: contractItemRow, gridColumn: 3}}
            />
            <PalantirDatePicker
                value={contract[ProjectPermit.columnSchema.approvalDate]}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.approvalDate]: x})}
                style={{gridRow: contractItemRow, gridColumn: 4}}
            />
            <PalantirDatePicker
                value={contract[ProjectPermit.columnSchema.expirationDate]}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.expirationDate]: x})}
                style={{gridRow: contractItemRow, gridColumn: 5}}
            />
            <PalantirTextField
                value={contract[ProjectPermit.columnSchema.documentLink]}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.documentLink]: x})}
                style={{gridRow: contractItemRow, gridColumn: 6}}
            />
            <PalantirDispatchedTextField
                value={contract[ProjectPermit.columnSchema.description]}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.description]: x})}
                style={{gridRow: contractItemRow, gridColumn: 7}}
            />
            {/*<PalantirAutocomplete
                value={{label: counterparty[Counterparty.columnSchema.counterpartyName], id: counterpartyId}}
                options={counterparties.map(cp => {
                    return {
                        label: cp[Counterparty.columnSchema.counterpartyName], id: cp[Counterparty.columnSchema.counterpartyId]
                    }
                })}
                onUpdate={(value) => updateContract({[ProjectPermit.columnSchema.responsibility]: value.id})}
                style={{gridRow: contractItemRow, gridColumn: 6}}
            />*/}
            {/*<PalantirSelector
                value={contract[ProjectPermit.columnSchema.jurisdictionLevel]}
                items={ProjectPermit.options.jurisdictionLevel}
                onChange={(x) => updateContract({[ProjectPermit.columnSchema.jurisdictionLevel]: x})}
                style={{gridRow: contractItemRow, gridColumn: 7, minWidth: "0px"}}
            />*/}
            {/*isContractDatesVisible &&
                <div style={{gridRow: contractDateTableRow, gridColumn: "1 / span 6", display: "grid", gridTemplateColumns: "50px auto 140px 160px 160px", gridTemplateRows: "20px 30px auto", columnGap: "20px", rowGap: "10px", marginLeft: "30px", marginBottom: "15px"}}>
                    <Text weight={500} style={{gridRow: 1, gridColumn: "1 / -1"}}>Dates</Text>
                    <div style={{gridRow: 2, gridColumn: 1}}><Text size="lg" style={{borderBottom: "dotted grey 1px"}}>ID</Text></div>
                    <div style={{gridRow: 2, gridColumn: 2}}><Text size="lg" style={{borderBottom: "dotted grey 1px"}}>Title</Text></div>
                    <div style={{gridRow: 2, gridColumn: 3}}><Text size="lg" style={{borderBottom: "dotted grey 1px"}}>Status</Text></div>
                    <div style={{gridRow: 2, gridColumn: 4}}><Text size="lg" style={{borderBottom: "dotted grey 1px"}}>Start Date</Text></div>
                    <div style={{gridRow: 2, gridColumn: 5}}><Text size="lg" style={{borderBottom: "dotted grey 1px"}}>End Date</Text></div>
                    <div style={{gridRow: 2, gridColumn: 6}}><Text size="lg" style={{borderBottom: "dotted grey 1px"}}>Description</Text></div>
                    {filteredContractDateComponents}
                    <div style={{gridRow: contractDateTableCtr, gridColumn: "1 / -1"}}>
                        <AddFloaterButtonWithPrompt
                            onClick={addContractDate}
                            labelContent="Add date"
                        />
                    </div>
                    
                </div>
            */}
        </>
    )
}

/*
const ContractDate = ({gridRow, contractDate, updateContractDate, deleteContractDate}) => {
    return (
        <>
            <DeleteFloaterButtonWithPrompt
                onClick={deleteContractDate}
                style={{gridRow: gridRow, gridColumn: 1, position: "relative", top: "0px", right: "22px"}}
            />
            <PalantirTextField
                value={contractDate[PermittingDatesContract.columnSchema.oid]}
                disabled
                style={{gridRow: gridRow, gridColumn: 1}}
            />
            <PalantirTextField
                value={contractDate[PermittingDatesContract.columnSchema.title]}
                onChange={(x) => updateContractDate({[PermittingDatesContract.columnSchema.title]: x})}
                style={{gridRow: gridRow, gridColumn: 2}}
            />
            <PalantirSelector
                value={contractDate[PermittingDatesContract.columnSchema.status]}
                items={PermittingDatesContract.options.status}
                onChange={(x) => updateContractDate({[PermittingDatesContract.columnSchema.status]: x})}
                style={{gridRow: gridRow, gridColumn: 3, minWidth: "0px"}}
            />
            <PalantirDatePicker
                value={contractDate[PermittingDatesContract.columnSchema.startDate]}
                onChange={(x) => updateContractDate({[PermittingDatesContract.columnSchema.startDate]: x})}
                style={{gridRow: gridRow, gridColumn: 4}}
            />
            <PalantirDatePicker
                value={contractDate[PermittingDatesContract.columnSchema.endDate]}
                onChange={(x) => updateContractDate({[PermittingDatesContract.columnSchema.endDate]: x})}
                style={{gridRow: gridRow, gridColumn: 5}}
            />
            <PalantirDispatchedTextField
                value={contractDate[PermittingDatesContract.columnSchema.description]}
                onChange={(x) => updateContractDate({[PermittingDatesContract.columnSchema.description]: x})}
                style={{gridRow: gridRow, gridColumn: 6}}
            />
        </>
    )
}
*/